import React, { useContext, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";

import { AnswerContext } from "../../../index";
import { Input } from "../../../../../Theme";
import { Form } from "../styles";

function EditItem() {
  const { state, dispatch } = useContext(AnswerContext);
  const formRef = useRef();

  const [itemToEdit, setItemToEdit] = useState(
    state.itens[state.inEditing.index]
  );

  React.useEffect(() => {}, [state]);

  function handleSubmit(event) {
    event.preventDefault();
    dispatch({
      type: "UPDATE_ITEM",
      index: state.inEditing.index,
      item: itemToEdit,
    });
  }

  function updateAndNext() {
    formRef.current.price.blur();
    dispatch({
      type: "UPDATE_ITEM_AND_NEXT",
      item: itemToEdit,
    });
    const priceOfPreviousItem = itemToEdit.price
    setItemToEdit({
      ...state.itens[state.inEditing.index + 1],
      price: priceOfPreviousItem,
    });

    if (state.itens.length === state.inEditing.index + 1) return;

    setTimeout(() => {
      formRef.current.price.focus();
    }, 100);
  }

  function handleCancel() {
    dispatch({
      type: "END_EDIT_ITEM",
    });
  }

  function handleChange(event, value) {
    if (event.target.name === "price")
      return setItemToEdit({
        ...itemToEdit,
        price: value,
      });
    if (event.target.name === "printDescription")
      return setItemToEdit({
        ...itemToEdit,
        [event.target.name]: event.target.value,
      });
    if (event.target.name === "details")
      return setItemToEdit({
        ...itemToEdit,
        [event.target.name]: event.target.value,
      });
  }

  return (
    <Form onSubmit={handleSubmit} ref={formRef}>
      <TextField
        name="printDescription"
        placeholder="Ex: Pão Tradicional"
        required
        value={itemToEdit.printDescription}
        autoFocus={true}
        label="Descrição"
        variant="outlined"
        fullWidth
        onChange={handleChange}
        size="medium"
      />

      <TextField
        name="details"
        placeholder="Ex: farinha de trigo, castanhas ..."
        value={itemToEdit.details}
        label="Detalhes (Opcional)"
        variant="outlined"
        fullWidth
        onChange={handleChange}
        size="medium"
      />
      <CurrencyTextField
        onKeyDown={(e) => {
          if (e.key === "ArrowDown") {
            updateAndNext();
          }
        }}
        label="Preço"
        style={{ width: "120px" }}
        variant="outlined"
        placeholder="0"
        currencySymbol="R$"
        name="price"
        required
        minimumValue="0"
        outputFormat="number"
        decimalCharacter=","
        digitGroupSeparator="."
        value={itemToEdit.price}
        onChange={handleChange}
        size="medium"
      />

      <div>
        <Button type="submit" variant="contained" color="primary">
          Alterar
        </Button>
        <Button onClick={handleCancel} variant="text" color="primary">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default EditItem;
